import { myIcons } from "@/utils/icons"
import { motion } from "framer-motion"
import "./style.css";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import statics from "@/utils/statics.json";
const { iconBaseUrl } = statics;

export const Education = () => {
    const { t } = useTranslation();
    const education = t("education", {
        returnObjects: true
    }) as Array<{
        id: string;
        school: string;
        department: string;
        degree: string;
        year: string;
        reward: string;
    }>;


    return <div
        style={{ color: 'var(--color-text)', }}
    >
        <p
            style={{
                fontSize: '25px',
                marginBottom: '20px',
            }}
        >{t("education-title")}</p>
        <>
            {education.map(item => (
                <EducationItem
                    key={item.id}
                    icon={`${iconBaseUrl}${item.id}.svg`}
                    school={item.school}
                    department={item.department}
                    degree={item.degree}
                    year={item.year}
                    reward={item.reward}
                />
            ))}
        </>
    </div>
}

interface EducationItemPropsI {
    icon: string,
    school: string
    department: string
    degree: string
    year: string
    reward?: string
}

const EducationItem = ({ icon, school, department, degree, year, reward }: EducationItemPropsI) => {
    return <motion.div
        className="education-item"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        style={{
            display: 'flex',
            gap: '20px',
            marginBottom: '30px'
        }}
    >
        <div
            style={{
                display: 'flex',
                backgroundColor: '#dcdcdcff',
                alignItems: 'center',
                width: '50px',
                height: '50px',
                padding: '5px',
                borderRadius: '10px',
                boxShadow: '0 2px 8px rgba(33, 33, 33, 0.5)',
            }}
        >
            <img
                style={{
                    display: 'flex',
                    width: '100%',
                }}
                src={icon} alt="" />
        </div>

        <div>
            <p style={{ fontWeight: 'bold' }} >{school}</p>
            <p>{department}</p>
            <p
                style={{
                    backgroundColor: '#3f51b5',
                    display: 'inline-block',
                    padding: '2px 5px',
                    borderRadius: '5px',
                    color: 'white',
                    userSelect: 'none',
                    margin: '10px 10px 10px 0px'
                }}
            >
                {degree}
            </p>
            {reward && (
                <p
                    style={{
                        backgroundColor: '#3f51b5',
                        display: 'inline-block',
                        padding: '2px 5px',
                        borderRadius: '5px',
                        color: 'white',
                        userSelect: 'none',
                        margin: '10px 0px'
                    }}
                >
                    {reward}
                </p>
            )}

            <p>{year}</p>
        </div>

    </motion.div>
}